var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogOff(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 4.00881C13.0002 3.45653 12.5527 3.00864 12.0004 3.00842C11.4481 3.00821 11.0002 3.45575 11 4.00803L10.9968 12.0115C10.9966 12.5638 11.4442 13.0117 11.9965 13.0119C12.5487 13.0121 12.9966 12.5645 12.9968 12.0123L13 4.00881Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4 12.9916C4 10.7824 4.89541 8.78247 6.34308 7.33476L7.7573 8.74898C6.67155 9.83476 6 11.3347 6 12.9916C6 16.3053 8.68629 18.9916 12 18.9916C15.3137 18.9916 18 16.3053 18 12.9916C18 11.3347 17.3284 9.83469 16.2426 8.74891L17.6568 7.33469C19.1046 8.78241 20 10.7824 20 12.9916C20 17.4098 16.4183 20.9916 12 20.9916C7.58172 20.9916 4 17.4098 4 12.9916Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogOff);
export default __webpack_public_path__ + "static/media/log-off.301403cf7fc2ad41c013797c38befbdc.svg";
export { ForwardRef as ReactComponent };